module.exports = __webpack_public_path__ + "static/media/mode-0.c0038b69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-0.svg
// module id = 973
// module chunks = 2